<template>
    <div class="dashboard">
        <div class="dPFSection">
            <div class="dSection dark secLg">
                <div class="dsHeader">
                    {{ $t('Home.dashboard.overview.allPortfolios') }}
                    <HoldingsPieChartDialog :dark="true"></HoldingsPieChartDialog>
                    <ObjectivesOverviewDialog :dark="true"></ObjectivesOverviewDialog>
                </div>
                <font-awesome-icon :icon="icons.portfolio" class="fa-fw sectionIcon" color="#EEE"></font-awesome-icon>
                <DashboardOverview2></DashboardOverview2>
                <PortfolioStockList :data="positions" class="sectionPadding"></PortfolioStockList>
                <PortfolioWidget></PortfolioWidget>
            </div>
            <div class="dSection tr">
                <div class="dsHeader">{{ $t('Home.dashboard.overview.transactions') }}</div>
                <TransactionList :transactionList="userTransactions"></TransactionList>
            </div>
        </div>
        <div class="dSection">
            <div class="dsHeader">
                <div class="dshTitle">{{ $t('Home.dashboard.overview.allBuyLists') }}</div>
                <div class="dshAction">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <BuyListsConfigDialog ref="buyListsConfig">
                                    <v-btn icon color="agora">
                                        <font-awesome-icon :icon="icons.config" class="fa-lg"></font-awesome-icon>
                                    </v-btn>
                                </BuyListsConfigDialog>
                            </div>
                        </template>
                        <span>{{ $t('Home.dashboard.overview.configureBuyLists') }}</span>
                    </v-tooltip>
                </div>
            </div>
            <font-awesome-icon :icon="icons.buy" class="fa-fw sectionIcon" color="#333"></font-awesome-icon>
            <BestSuggestionsWidget type="buy"></BestSuggestionsWidget>
            <ListWidget type="buy"></ListWidget>
        </div>
        <div class="dSection">
            <div class="dsHeader">{{ $t('Home.dashboard.overview.allSellLists') }}</div>
            <font-awesome-icon :icon="icons.sell" class="fa-fw sectionIcon" color="#333"></font-awesome-icon>
            <BestSuggestionsWidget type="sell"></BestSuggestionsWidget>
            <ListWidget type="sell"></ListWidget>
        </div>
    </div>
</template>

<script>
import HoldingsPieChartDialog from '../../components/controls/HoldingsPieChartDialog.vue';
import ObjectivesOverviewDialog from '../../components/controls/ObjectivesOverviewDialog.vue';
import ListRegularIconMixin from '../../components/help/icons/ListRegularIconMixin';
import DashboardOverview2 from '../../components/home/dashboard/DashboardOverview2.vue';
import BestSuggestionsWidget from '../../components/list/BestSuggestionsWidget.vue';
import ListWidget from '../../components/list/ListWidget.vue';
import PortfolioStockList from '../../components/portfolio/PortfolioStockList.vue';
import PortfolioWidget from '../../components/portfolio/PortfolioWidget.vue';
import TransactionList from '../../components/portfolio/TransactionList.vue';
import UserDataHelperMixin from '../../infra/UserDataHelperMixin';
import BuyListsConfigDialog from './BuyListsConfigDialog.vue';
export default {
    mixins: [UserDataHelperMixin, ListRegularIconMixin],
	components: {
        DashboardOverview2,
        PortfolioWidget,
        BestSuggestionsWidget,
        ListWidget,
        TransactionList,
        BuyListsConfigDialog,
        HoldingsPieChartDialog,
        ObjectivesOverviewDialog,
        PortfolioStockList
    },
    computed: {
        userTransactions() {
            return this.$store.getters.userTransactions
        },
        positions() {
            return this.myData ? this.myData.positions : [];
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.dashboard {
    height: 100%;
    background-color: #FFF;
    display: flex;
    gap: 25px;
    padding: 20px;
    .dPFSection {
        display: flex;
        gap: 10px;
        flex: 2;
        border-radius: 10px;
        background-color: var(--darkBG);
        padding: 20px;
        .dSection {
            padding: 0;
            .sectionPadding {
                padding: 10px;
            }
        }
        .dsHeader {
            display: flex;
            gap: 10px;
            align-items: center;
            color: #FFF;
        }
    }
    .dSection {
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 1;
        background-color: var(--lightBG);
        border-radius: 10px;
        padding: 20px;
        position: relative;
        overflow: hidden;
        .sectionIcon {
            opacity: 0.2;
            position: absolute;
            top: -5px;
            right: 20px;
            font-size: 90px;
            rotate: -15deg;
        }
        &.dark {
            background-color: var(--darkBG);
            .dsHeader {
                color: #FFF;
            }
        }
        &.tr {
            background-color: var(--darkBG);
            .dsHeader {
                color: #FFF;
            }
        }
        &.secLg {
            flex: 3;
        }
        .dsHeader {
            display: flex;
            gap: 10px;
            font-size: 1.5em;
            font-weight: bold;
            border-radius: 10px 10px 0 0;
        }
    }
    @media screen and (max-width: $large) {
        padding: 20px 10px;
        gap: 10px;
    }
}
</style>